import { colors, textSizes } from '@components/theme/styles/index';
import { rem, rgba } from 'polished';
import styled from 'styled-components';
import { ProgressBarColorValue } from './progress-bar';

export const StyledProgressBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;

export const StyledProgress = styled.progress<{
  $color?: ProgressBarColorValue;
}>`
  width: 100%;
  border: none;
  border-radius: ${rem(3)};
  height: ${rem(6)};

  &::-webkit-progress-bar {
    background-color: ${colors.grayLight2};
    border-radius: ${rem(3)};
  }

  &::-webkit-progress-value {
    background-color: ${(props) => {
      if (!props.$color) return rgba(colors.primary, 0.4);

      // Check if it's a hex color (starts with #)
      if (typeof props.$color === 'string' && props.$color.startsWith('#')) {
        return rgba(props.$color, 0.4);
      }

      // Otherwise, treat it as a predefined color
      return (
        (colors as Record<string, string>)[props.$color] ||
        rgba(colors.primary, 0.4)
      );
    }};
    border-radius: ${rem(3)};
  }

  &[value] {
    background-color: ${colors.grayLight2};
  }

  &::-moz-progress-bar {
    background-color: ${(props) => {
      if (!props.$color) return rgba(colors.primary, 0.4);

      // Check if it's a hex color (starts with #)
      if (typeof props.$color === 'string' && props.$color.startsWith('#')) {
        return rgba(props.$color, 0.4);
      }

      // Otherwise, treat it as a predefined color
      return (
        (colors as Record<string, string>)[props.$color] ||
        rgba(colors.primary, 0.4)
      );
    }};
  }
`;

export const StyledProgressBarLabel = styled.label`
  font-size: ${textSizes.sm};
  margin-bottom: ${rem(2)};
  color: ${colors.grayDark2};
`;
